<div class="card" [style.minHeight]="tileInstance.minHeight">
  <div class="background-container" [style.background]="backgroundStyle"></div>

  <div class="content-container">
    <div class="hero-section d-flex fd-row jc-center ai-center fd-col--lt-md">
      <div class="icons-container" *ngIf="tileInstance.icons?.length">
        <span
          class="material-icons border-circle lrg-icon light"
          *ngFor="let icon of tileInstance.icons"
        >
          {{ icon.icon }}
        </span>
      </div>

      <div
        class="positioned-content"
        [ngClass]="{
          'img-right': tileInstance.contentImgPosition === 'end',
          'img-left': tileInstance.contentImgPosition === 'start',
          'img-top': tileInstance.contentImgPosition === 'top',
          'img-bottom': tileInstance.contentImgPosition === 'bottom',
        }"
      >
        <div
          class="content-left basis-100--lt-md"
          [style.textAlign]="tileInstance.alignContent"
        >
          <div style="height: 100%" class="d-flex fd-col jc-center ai-center">
            <div class="flex-1 slide-right padding-x5">
              <h1 class="title" [style.fontSize]="tileInstance.headingFontSize | pxSuffix">
                <span [style.color]="tileInstance.heading1FontColor">{{
                  tileInstance.heading1
                }}</span>
                <span [style.color]="tileInstance.heading2FontColor">{{
                  tileInstance.heading2
                }}</span>
              </h1>
              <div [style.fontSize]="tileInstance.textFontSize | pxSuffix">
                <p class="description" [style.color]="tileInstance.textFontColor">
                  {{ tileInstance.text }}
                </p>
              </div>

              <button
                *ngFor="let linkButton of tileInstance.linkButtons"
                mat-raised-button
                [routerLink]="linkButton.routeLink"
                [style.color]="linkButton.buttonFontColor"
                [style.fontSize]="linkButton.buttonFontSize | pxSuffix"
                [style.backgroundColor]="linkButton.buttonBackgroundColor"
                class="free-trial-button slide-top"
              >
                {{ linkButton.buttonText }}
              </button>
            </div>
          </div>
        </div>

        <div
          class="content-right d-flex jc-center ai-center order-2"
        >
          <!-- TODO: Handle fxShow and fxHide.xs responsive visibility -->
          <!-- TODO: Handle fxFlexOrder.lt-md="-1" responsive order -->
          <img class="splash-image slide-left" [src]="contentImgPath" />
        </div>
      </div>
    </div>
  </div>
  <div class="fab-container" *ngIf="tileInstance.minHeight == '100vh'">
    <span mat-button (click)="scrollToElement(bannerTileEnd)">
      <i class="chevron-down-o"></i>
    </span>
  </div>
</div>

<div #bannerTileEnd></div>
